import { connect, MapStateToProps } from "react-redux";

import { getPrimaryText } from "@multiweb/reactCore/i18n";
import { IAppState } from "@multiweb/types/react";
import { GroupHeaderComponent, GroupHeaderComponentProps } from "../GroupHeaderComponent";

export type GroupHeaderProps = {
    /** Lokalizační klíč pro nadpis skupiny */
    locKey: string;
};

const mapStateToProps: MapStateToProps<GroupHeaderComponentProps, GroupHeaderProps, IAppState> = (state, { locKey }) => ({
    label: getPrimaryText(state, locKey),
});

export const GroupHeader = connect(mapStateToProps)(GroupHeaderComponent);
